import React from "react";
import {
  Box,
  VStack,
  Text,
  Input,
  Select,
} from "@chakra-ui/react";

const MandateForm = ({
  formValues,
  setFormValues,
  availableBanks,
  verifyingAccount,
  accountInfo,
}) => {
  return (
    <VStack w="100%" align="baseline" spacing={3}>
      <Box mt="20px" w="100%">
        <Text fontWeight="500" fontSize="13px" color="text.primary">
          Monthly Repayment Amount
        </Text>
        <Input
          type="number"
          mt="10px"
          value={formValues.monthly_repayment}
          onChange={(e) =>
            setFormValues({
              ...formValues,
              monthly_repayment: e.target.value,
            })
          }
          className="form-input"
          placeholder="Enter Amount"
        />

        <Text fontWeight="500" fontSize="13px" color="text.primary" mt="20px">
          Select Direct Debit Gateway
        </Text>
        <Select
          value={formValues.gateway}
          onChange={(e) =>
            setFormValues({
              ...formValues,
              gateway: e.target.value,
            })
          }
          className="form-input"
        >
          <option value="">Select Gateway</option>
          <option value="paystack">Paystack</option>
          <option value="mono">Mono</option>
          <option value="card">Card</option>
        </Select>

        {formValues.gateway === "mono" && (
          <Box
            mt="24px"
            p="20px"
            borderRadius="16px"
            bg="brand.50"
            boxShadow="0 2px 12px rgba(91,46,79,0.08)"
            w="100%"
          >
            <Text fontWeight="600" fontSize="15px" color="brand.500" mb="8px">
              Bank Details
            </Text>
            <VStack spacing={4} align="stretch">
              <Box>
                <Text fontWeight="500" fontSize="13px" color="text.primary">
                  Select Bank
                </Text>
                <Select
                  value={formValues.bank_code}
                  onChange={(e) =>
                    setFormValues({
                      ...formValues,
                      bank_code: e.target.value,
                    })
                  }
                  className="form-input"
                  placeholder="Select Bank"
                  mt="8px"
                  bg="white"
                  borderColor="brand.100"
                >
                  <option value="">Select Bank</option>
                  {availableBanks.map((bank) => (
                    <option key={bank.bank_code} value={bank.bank_code}>
                      {bank.name}
                    </option>
                  ))}
                </Select>
              </Box>
              <Box>
                <Text fontWeight="500" fontSize="13px" color="text.primary">
                  Account Number
                </Text>
                <Input
                  type="text"
                  mt="8px"
                  value={formValues.account_number || ""}
                  onChange={(e) =>
                    setFormValues({
                      ...formValues,
                      account_number: e.target.value,
                    })
                  }
                  className="form-input"
                  placeholder="Enter Account Number"
                  maxLength={10}
                  minLength={10}
                  bg="white"
                  borderColor="brand.100"
                />
              </Box>
              <Box minH="24px">
                {formValues?.account_number?.length === 10 &&
                  (verifyingAccount ? (
                    <Text color="brand.500" fontSize="13px" fontWeight="500">
                      Verifying account...
                    </Text>
                  ) : accountInfo ? (
                    <Text
                      fontWeight="500"
                      fontSize="13px"
                      color="green.600"
                      mb="10px"
                    >
                      {accountInfo}
                    </Text>
                  ) : null)}
              </Box>
            </VStack>
          </Box>
        )}
      </Box>
    </VStack>
  );
};

export default MandateForm;
